<div class="row">
  <div class="col-sm-12 col-lg-4 form-group">
    <input type="text" placeholder="Fecha de Inicio" class="form-control" bsDatepicker
      [bsConfig]="{ adaptivePosition: true, dateInputFormat: 'DD/MM/YYYY', showWeekNumbers: false }"
      [(bsValue)]="fechaInicio" [maxDate]="fechaFin" [minDate]="minFechaInicio" readonly>
  </div>
  <div class="col-sm-12 col-lg-4 form-group">
    <input type="text" placeholder="Fecha Fin" class="form-control" bsDatepicker
      [bsConfig]="{ adaptivePosition: true, dateInputFormat: 'DD/MM/YYYY', showWeekNumbers: false}"
      [(bsValue)]="fechaFin" [minDate]="fechaMinima" readonly>
  </div>
  <div class="col-sm-12 col-lg-4 d-flex justify-content-start align-items-center">
    <button type="button" class="btn btn-outline-primary d-flex align-items-center mb-4 mr-2"
      (click)="ObtenerMovimientos()">
      <span class="material-icons">search</span>
      Buscar
    </button>

  </div>
  <div class="col-12">
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th scope="col" class="text-uppercase text-left">Fecha</th>
            <th scope="col" class="text-uppercase text-center">Documento</th>
            <th scope="col" class="text-uppercase text-center">Transacción</th>
            <th scope="col" class="text-uppercase text-center">Concepto</th>
            <th scope="col" class="text-uppercase text-right">Valor</th>
            <th scope="col" class="text-uppercase text-right">Saldo</th>
            <th scope="col" class="text-uppercase text-left">Fecha de la Máquina</th>
            <th scope="col" class="text-uppercase text-left">Comprobante</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="movimientos?.length === 0">
            <td colspan="6" class="text-uppercase text-center">No hay información para mostrar</td>
          </tr>
          <tr *ngFor="let movimiento of movimientos">
            <td class="text-left">{{movimiento?.fecha}}</td>
            <td class="text-center">{{movimiento?.documento}}</td>
            <td class="text-center">{{movimiento?.transaccion}}</td>
            <td class="text-center">{{movimiento?.concepto}}</td>
            <td class="text-right">{{movimiento?.valor | currency}}</td>
            <td class="text-right">{{movimiento?.saldo | currency}}</td>
            <td class="text-left">{{movimiento?.fechaMaquina}}</td>
            <td style="text-align: center">
              <button type="button" class="btn btn-outline-light" *ngIf="reimprimible(movimiento)"
                (click)="devuelveComprobantePdf(movimiento)">
                <span class="material-icons btn-outline-primary">download</span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="d-flex justify-content-between p-2">
        <ngb-pagination [collectionSize]="cantidad" [(page)]="pagina" [pageSize]="paginaTamanio" [rotate]="true"
          [maxSize]="5" [boundaryLinks]="true" (pageChange)="ObtenerMovimientos()">
        </ngb-pagination>

        <select class="custom-select" style="width: auto" [(ngModel)]="paginaTamanio"
          (ngModelChange)="ObtenerMovimientos()">
          <option [ngValue]="3">3 movimientos por página</option>
          <option [ngValue]="5">5 movimientos por página</option>
          <option [ngValue]="10">10 movimientos por página</option>
        </select>
      </div>
    </div>
  </div>
  <!--<button type="button" class="btn btn-outline-primary d-flex align-items-center mb-4" (click)="DescargarPdf()">
    <span class="material-icons">assignment</span>
    Estado de Cuenta  
  </button>-->
</div>


<div id="comprobante" *ngIf="mostrarComprobante" class="col-12 col-lg-6 mx-auto">

  <div class="card card-comprobante">
    <div class="card-header text-center d-block">
      <div class="header-comprobante">
        <img class="img-fluid coac" src="../../../assets/images/logohori.png" alt="">
      </div>
      <hr>
      <div class="d-flex justify-content-center">
        <img class="img-fluid check" src="../../../assets/images/check_icon.png" alt="check-icon" />
      </div>
      <p class="text-primary h4">¡Transferencia exitosa!</p>
      <p class="text-muted subtitle">Número de comprobante</p>
      <p class="text-primary subtitle">{{ comprobante?.secuencialMovimiento }}</p>
    </div>

    <div class="card-body">
      <div class="monto d-flex justify-content-between">
        <p class="text-primary negrita">Monto</p>
        <p class="text-primary negrita">{{ comprobante?.monto | currency }}</p>
      </div>
      <div class="fecha d-flex justify-content-between">
        <p class="text-primary ligth ">Fecha</p>
        <p class="text-primary ligth">{{ comprobante?.fecha | date:'dd/MM/yyyy, HH:mm:ss' }}</p>

      </div>
      <hr>

      <div class="debita">
        <p class="negrita text-primary mb-2">Cuenta debitada</p>
        <p class="text-primary negrita text-uppercase"> {{this.usuario?.nombre}}</p>
      </div>
      <div class="debita-detalle d-flex justify-content-between">
        <p class="text-primary ligth text-uppercase"> {{ comprobante?.numeroCuentaOrigen | enmascararCuenta }}</p>
        <p class="text-primary ligth text-uppercase"> {{comprobante?.tipoCuentaOrigen}}</p>
      </div>
      <hr>

      <div class="acredita">
        <p class="negrita text-primary mb-2">Cuenta acreditada</p>
        <p class="text-primary negrita">{{comprobante?.beneficiario}}</p>
      </div>
      <div class="debita-detalle d-flex justify-content-between">
        <p class="text-primary ligth text-uppercase"> {{ comprobante?.numeroCuentaDestino |enmascararCuenta }}</p>
        <p class="text-primary ligth text-uppercase"> {{comprobante?.tipoCuentaDestino}}</p>
      </div>
      <p class="text-primary text-uppercase"> {{ comprobante?.institucion }}</p>
      <div class="text-center mt-4">
        <p class="text-primary negrita ">Motivo de transferencia</p>
        <p class="text-primary motivo"> {{ comprobante?.concepto }}</p>
      </div>
    </div>
  </div>



</div>


<div id="comprobante" *ngIf="mostrarComprobantePrestamo" class="col-12 col-lg-6 mx-auto">
  <div class="card card-comprobante">
    <div class="card-header text-center d-block">
      <div class="header-comprobante">
        <img class="img-fluid coac" src="../../../assets/images/logohori.png" alt="" />
      </div>
      <div class="d-flex justify-content-center">
        <img class="img-fluid check" src="../../../assets/images/check_icon.png" alt="check-icon" />
      </div>
      <p class="text-primary h4">Pago exitoso!</p>
      <p class="text-muted subtitle">Comprobante</p>
      <p class="text-primary subtitle">
        {{ comprobante?.numeroDocumento }}
      </p>
    </div>

    <div class="card-body detalle-pagos">
      <hr />

      <div class="debita">
        <p class="negrita text-primary mb-2">Cuenta debitada</p>
      </div>
      <div class="debita-detalle d-flex justify-content-between">
        <p class="text-primary ligth text-uppercase">
          {{ cuentaSeleccionada?.codigo |enmascararCuenta }}
        </p>
        <p class="text-primary ligth text-uppercase">
          {{ cuentaSeleccionada?.tipo }}
        </p>
      </div>
      <hr />

      <div class="acredita">
        <p class="negrita text-primary mb-2">Detalle de pago</p>
      </div>
      <div class="debita-detalle justify-content-between d-flex">
        <p class="text-primary negrita text-uppercase">Fecha</p>
        <div class="text-primary ligth text-uppercase">
          {{comprobante?.fecha}}
        </div>
      </div>
      <!-- <div class="debita-detalle justify-content-between d-flex">
          <p class="text-primary negrita text-uppercase">Cuotas</p>
          <div class="text-primary ligth text-uppercase">
            <span>{{cuota}}/{{totalCuotas}}</span>
          </div>
        </div>  -->

      <div class="debita-detalle justify-content-between d-flex">
        <p class="text-primary negrita text-uppercase">Valor</p>
        <div class="text-primary ligth text-uppercase">
          {{ comprobante?.valor |currency }}
        </div>
      </div>

    </div>
    <div class="text-center mt-2">
      <p class="text-primary negrita ">Motivo</p>
      <p class="text-primary motivo"> {{ comprobante?.concepto }}</p>
    </div>
    <p class="text-center subtitle text-primary mb-2">Gracias por su pago.</p>
  </div>
</div>